<template>
  <div class="room gas-clamp">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>上游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">送气夹</div>
          <div class="exhaust">排气夹</div>
          <div class="circle">回气夹</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">广州(海鸥岛)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">东莞</span>
        </div>
        <div class="cable-img">
          <el-tooltip
            class="station-block station-block-1"
            content="1号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation1/anchorAfan"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-2"
            content="5号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation5/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-3"
            content="6号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation6/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-4"
            content="3号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation3/anchorAfan"
            ></router-link>
          </el-tooltip>
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`top-item-${$index}`"
            v-for="(item,$index) in topList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p>{{item.minName}}</p>
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>下游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">送气夹</div>
          <div class="exhaust">排气夹</div>
          <div class="circle">回气夹</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">广州(海鸥岛)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">东莞</span>
        </div>
        <div class="cable-img">
          <el-tooltip
            class="station-block station-block-1"
            content="2号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation2/anchorAfan"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-2"
            content="5号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation5/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-3"
            content="6号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation6/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-4"
            content="4号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/niZhou/prepStation4/anchorAfan"
            ></router-link>
          </el-tooltip>
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`bottom-item-${$index}`"
            v-for="(item,$index) in bottomList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p>{{item.minName}}</p>
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'gasClamp',
  data() {
    return {
      loading: true,
      topList: [
        {
          name: '坭洲5#制备站气夹SP1',
          minName: '排风/SP1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SP1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP1气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SS1',
          minName: '送风/SS1',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SS1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS1气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS1气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SP2',
          minName: '回风/SP2',
          className: 'circle',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SP2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP2气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SS2',
          minName: '送风/SS2',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SS2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS2气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS2气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SP3',
          minName: '排风/SP3',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SP3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP3气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SP4',
          minName: '排风/SP4',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SP4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP4气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹SS3',
          minName: '送风/SS3',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SS3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS3气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS3气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SP5',
          minName: '回风/SP5',
          className: 'circle',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SP5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP5气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SS4',
          minName: '送风/SS4',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'SS4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS4气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS4气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SP6',
          minName: '回风/SP6',
          className: 'circle',
          errorLevel: '',
          opsName: 'bottom-pos',
          list: [
            {
              deviceName: 'SP6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP6气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP6气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SS5',
          minName: '送风/SS5',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SS5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS5气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS5气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SP7',
          minName: '回风/SP7',
          className: 'circle',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'SP7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP7气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SS6',
          minName: '送风/SS6',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SS6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS6气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS6气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS6气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹SP8',
          minName: '排风/SP8',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'SP8气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP8气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP8气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹SP9',
          minName: '排风/SP9',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SP9气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP9气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP9气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹SS7',
          minName: '送风/SS7',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SS7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SS7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SS7气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SS7气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹SP10',
          minName: '排风/SP10',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SP10气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SP10气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SP10气夹压力(Pa)',
              value: null
            }
          ]
        }
      ],
      bottomList: [
        {
          name: '坭洲5#制备站气夹XP1',
          minName: '排风/XP1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XP1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP1气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XS1',
          minName: '送风/XS1',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XS1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS1气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS1气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XP2',
          minName: '回风/XP2',
          className: 'circle',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XP2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP2气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XS2',
          minName: '送风/XS2',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XS2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS2气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS2气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XP3',
          minName: '排风/XP3',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XP3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP3气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XP4',
          minName: '排风/XP4',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XP4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP4气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲5#制备站气夹XS3',
          minName: '送风/XS3',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XS3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS3气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS3气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XP5',
          minName: '回风/XP5',
          className: 'circle',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XP5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP5气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XS4',
          minName: '送风/XS4',
          className: 'supply',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'XS4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS4气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS4气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XP6',
          minName: '回风/XP6',
          className: 'circle',
          errorLevel: '',
          opsName: 'bottom-pos',
          list: [
            {
              deviceName: 'XP6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP6气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP6气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XS5',
          minName: '送风/XS5',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XS5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS5气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS5气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XP7',
          minName: '回风/XP7',
          className: 'circle',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'XP7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP7气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XS6',
          minName: '送风/XS6',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XS6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS6气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS6气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS6气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲6#制备站气夹XP8',
          minName: '排风/XP8',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'XP8气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP8气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP8气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹XP9',
          minName: '排风/XP9',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XP9气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP9气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP9气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹XS7',
          minName: '送风/XS7',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XS7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XS7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XS7气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XS7气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '坭洲3#制备站气夹XP10',
          minName: '排风/XP10',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XP10气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XP10气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XP10气夹压力(Pa)',
              value: null
            }
          ]
        }
      ],
      timeFunc: null,
      deviceList: [
        {
          deviceName: 'SP10气夹湿度(%)',
          deviceId: 'f6a89105-7bbd-4829-93b0-f772dd97eacb'
        },
        {
          deviceName: 'SP1气夹湿度(%)',
          deviceId: '7b09ef41-2dda-4efb-a2d1-8e4fcdf0b924'
        },
        {
          deviceName: 'SP2气夹湿度(%)',
          deviceId: '1c44a65e-f6a9-4589-a849-f67b00024b7c'
        },
        {
          deviceName: 'SP3气夹湿度(%)',
          deviceId: 'c00861f2-d16b-4221-8095-3ed95eb1b41a'
        },
        {
          deviceName: 'SP4气夹湿度(%)',
          deviceId: 'bd455c1a-8dfd-4402-bc73-fcdf9305af22'
        },
        {
          deviceName: 'SP5气夹湿度(%)',
          deviceId: '8e7ab9b2-8185-47e6-b89b-4d81b8573b70'
        },
        {
          deviceName: 'SP6气夹湿度(%)',
          deviceId: '86a96967-3998-4b09-afc0-26ef20c4798d'
        },
        {
          deviceName: 'SP7气夹湿度(%)',
          deviceId: '84d37006-2839-4473-a388-2e45f569ea57'
        },
        {
          deviceName: 'SP8气夹湿度(%)',
          deviceId: 'c1baa90f-914e-486a-95e0-d4a6bef0b8d0'
        },
        {
          deviceName: 'SP9气夹湿度(%)',
          deviceId: 'b473ce6c-5711-4011-8178-8116938de2e4'
        },
        {
          deviceName: 'SS1气夹湿度(%)',
          deviceId: '2392bd12-f8c4-4c2f-86d8-e92313615397'
        },
        {
          deviceName: 'SS2气夹湿度(%)',
          deviceId: 'e9c47f58-3479-4e23-a724-549bb843c915'
        },
        {
          deviceName: 'SS3气夹湿度(%)',
          deviceId: '3b3cda0c-7166-4822-b51f-13edb10aadf8'
        },
        {
          deviceName: 'SS4气夹湿度(%)',
          deviceId: '5bccd5d1-357b-4426-8d54-1199cb511b6f'
        },
        {
          deviceName: 'SS5气夹湿度(%)',
          deviceId: 'd81db308-9b34-430b-8c60-fc4f493918bb'
        },
        {
          deviceName: 'SS6气夹湿度(%)',
          deviceId: '0a2c5a9f-1d09-462b-9b76-3e5cb615aa03'
        },
        {
          deviceName: 'SS7气夹湿度(%)',
          deviceId: '25e32eb6-fe29-4e9a-bf1d-0b5f5735c7b1'
        },
        {
          deviceName: 'XP10气夹湿度(%)',
          deviceId: 'be41e4dc-c2ae-4a72-8dca-05f65fef237f'
        },
        {
          deviceName: 'XP1气夹湿度(%)',
          deviceId: '3301c771-cc37-4c72-b15f-169408b051d6'
        },
        {
          deviceName: 'XP2气夹湿度(%)',
          deviceId: '87a77d90-b981-4125-aa6e-2db04881b062'
        },
        {
          deviceName: 'XP3气夹湿度(%)',
          deviceId: 'd451564b-b1fe-4cfb-b7c1-5e7d1508107e'
        },
        {
          deviceName: 'XP4气夹湿度(%)',
          deviceId: '3800dc7f-72a1-4077-91b4-0a5480605bd4'
        },
        {
          deviceName: 'XP5气夹湿度(%)',
          deviceId: '77045874-a2fb-465a-b01a-cec74bc0d6bc'
        },
        {
          deviceName: 'XP6气夹湿度(%)',
          deviceId: '2e6be70d-46b5-47db-b303-aad3e81175af'
        },
        {
          deviceName: 'XP7气夹湿度(%)',
          deviceId: '23c14c90-6528-4cb4-b450-81c88b9e2489'
        },
        {
          deviceName: 'XP8气夹湿度(%)',
          deviceId: 'b5cad317-73bd-4f68-852d-62c866aa83d9'
        },
        {
          deviceName: 'XP9气夹湿度(%)',
          deviceId: '03b51c5d-b9f4-4cd5-bf91-fb267f042574'
        },
        {
          deviceName: 'XS1气夹湿度(%)',
          deviceId: '106c0ed7-2a19-4387-97d8-12f534ce6ec8'
        },
        {
          deviceName: 'XS2气夹湿度(%)',
          deviceId: '8496b493-e72b-4b3d-9a5d-8bc08748e24e'
        },
        {
          deviceName: 'XS3气夹湿度(%)',
          deviceId: '6ca56b97-f6ab-4c0a-8a2f-4929d0af1ee6'
        },
        {
          deviceName: 'XS4气夹湿度(%)',
          deviceId: '25d0f68f-5424-4ef8-9423-7085b89e07a5'
        },
        {
          deviceName: 'XS5气夹湿度(%)',
          deviceId: '672ab1c6-8037-4f79-ad51-b24998db3ebb'
        },
        {
          deviceName: 'XS6气夹湿度(%)',
          deviceId: 'f27a5ef6-d4f1-441f-a45b-529b9401a559'
        },
        {
          deviceName: 'XS7气夹湿度(%)',
          deviceId: '5ad94a7c-e3c4-4bb3-af6c-b0cc30b0dfc0'
        },
        {
          deviceName: 'SP10气夹温度(℃)',
          deviceId: '6daf55b3-c5a8-4cb1-b9a8-a1c039eebcf5'
        },
        {
          deviceName: 'SP1气夹温度(℃)',
          deviceId: '413241ba-e099-4b80-9c3f-3808895aebf8'
        },
        {
          deviceName: 'SP2气夹温度(℃)',
          deviceId: 'e2f00642-f586-4769-bccc-f19cedc6f801'
        },
        {
          deviceName: 'SP3气夹温度(℃)',
          deviceId: 'd08bcdab-b9f6-453c-b924-41eb58d074ed'
        },
        {
          deviceName: 'SP4气夹温度(℃)',
          deviceId: '97ae947e-8f57-4247-a856-0a66503e6472'
        },
        {
          deviceName: 'SP5气夹温度(℃)',
          deviceId: '7a5b5994-1bad-4016-887d-9ecf30fa77ba'
        },
        {
          deviceName: 'SP6气夹温度(℃)',
          deviceId: '52d946fb-ec2a-4bf2-afeb-ffde860394e9'
        },
        {
          deviceName: 'SP7气夹温度(℃)',
          deviceId: '6785f18b-4844-4912-a293-eb3b71c11b56'
        },
        {
          deviceName: 'SP8气夹温度(℃)',
          deviceId: '37bb93d0-85f4-4449-b21f-a1cd669f6992'
        },
        {
          deviceName: 'SP9气夹温度(℃)',
          deviceId: '989ff5a0-701f-4bd5-831d-4711d74821d9'
        },
        {
          deviceName: 'SS1气夹温度(℃)',
          deviceId: 'e724ec68-3447-4b6b-a13c-93c2a655be96'
        },
        {
          deviceName: 'SS2气夹温度(℃)',
          deviceId: 'cbed5671-d40c-4968-9c3a-62efc290f2ba'
        },
        {
          deviceName: 'SS3气夹温度(℃)',
          deviceId: 'd74df382-c411-4078-af22-56c460641023'
        },
        {
          deviceName: 'SS4气夹温度(℃)',
          deviceId: '5fc9227e-e8c2-450d-8389-07dc15f33847'
        },
        {
          deviceName: 'SS5气夹温度(℃)',
          deviceId: 'c3e70bdb-5808-4db1-bde7-bc337a892d52'
        },
        {
          deviceName: 'SS6气夹温度(℃)',
          deviceId: 'db79d5dd-9b79-4948-9fbf-746b6f6990bd'
        },
        {
          deviceName: 'SS7气夹温度(℃)',
          deviceId: '45168aff-9001-48bc-9f70-a8fa30d641d6'
        },
        {
          deviceName: 'XP10气夹温度(℃)',
          deviceId: 'a55d9806-c74f-4546-bad0-5a08424a5e67'
        },
        {
          deviceName: 'XP1气夹温度(℃)',
          deviceId: 'e83d2a1a-2433-408f-b35f-3dfdfe22eee8'
        },
        {
          deviceName: 'XP2气夹温度(℃)',
          deviceId: 'ddca59f5-54ff-48b0-b61d-9c8f076e7647'
        },
        {
          deviceName: 'XP3气夹温度(℃)',
          deviceId: '1f7795db-f4cc-44c4-986f-2c96e94851c4'
        },
        {
          deviceName: 'XP4气夹温度(℃)',
          deviceId: '7df11967-9a33-40c6-9465-b0fb8520a33a'
        },
        {
          deviceName: 'XP5气夹温度(℃)',
          deviceId: 'e64deaf6-0098-40a4-9089-80cd47dded99'
        },
        {
          deviceName: 'XP6气夹温度(℃)',
          deviceId: '2549e336-db92-4c4f-b783-fed13d052cfc'
        },
        {
          deviceName: 'XP7气夹温度(℃)',
          deviceId: '37ed7ec1-9f20-4f97-91f9-a181558e08ea'
        },
        {
          deviceName: 'XP8气夹温度(℃)',
          deviceId: 'a6f6cbe6-6851-46ae-bd63-60eb0dfae8f2'
        },
        {
          deviceName: 'XP9气夹温度(℃)',
          deviceId: '8a8aa0ca-e51b-45fa-a9f6-8c41b5c1fa8d'
        },
        {
          deviceName: 'XS1气夹温度(℃)',
          deviceId: '973bb978-9f00-48b1-a50b-cd1af08e3739'
        },
        {
          deviceName: 'XS2气夹温度(℃)',
          deviceId: '106e9563-5e28-4239-bf34-bbf5cb8e548a'
        },
        {
          deviceName: 'XS3气夹温度(℃)',
          deviceId: 'aab25689-560c-4847-af3a-dc2140166cf6'
        },
        {
          deviceName: 'XS4气夹温度(℃)',
          deviceId: 'c363c780-3731-419c-8cab-bf3f9c4b5c87'
        },
        {
          deviceName: 'XS5气夹温度(℃)',
          deviceId: 'd30d527c-79c4-44a4-8d81-2ce89489c0cd'
        },
        {
          deviceName: 'XS6气夹温度(℃)',
          deviceId: 'fb12abac-c5c4-4cbe-b04e-f6cdc21b894f'
        },
        {
          deviceName: 'XS7气夹温度(℃)',
          deviceId: '037971fd-44d1-400a-b82e-48bd6ca4ad9e'
        },
        {
          deviceName: 'SS1气夹流量(m?/h)',
          deviceId: 'bfaf6720-f784-4fa7-b748-ccf7fbfb122d'
        },
        {
          deviceName: 'SS2气夹流量(m?/h)',
          deviceId: 'da4734d9-533a-455f-9162-ce6005a44eb7'
        },
        {
          deviceName: 'SS3气夹流量(m?/h)',
          deviceId: '36ddb666-c7fe-4e93-a34b-f6145355dfa4'
        },
        {
          deviceName: 'SS4气夹流量(m?/h)',
          deviceId: '84974a4f-6b23-4759-82eb-d4771e2e28a4'
        },
        {
          deviceName: 'SS5气夹流量(m?/h)',
          deviceId: '639e74a4-3b9d-4547-b1d3-4d28d9fa4431'
        },
        {
          deviceName: 'SS6气夹流量(m?/h)',
          deviceId: '3c936149-a472-4b33-8963-e929db50585f'
        },
        {
          deviceName: 'SS7气夹流量(m?/h)',
          deviceId: '4a8eb2e3-5d9f-4484-9cca-51d197693a43'
        },
        {
          deviceName: 'XS1气夹流量(m?/h)',
          deviceId: 'dbf93ff4-fe1a-401d-98f1-32400df9a627'
        },
        {
          deviceName: 'XS2气夹流量(m?/h)',
          deviceId: 'beec9db1-762e-4fd1-9f8c-71de9f9e976f'
        },
        {
          deviceName: 'XS3气夹流量(m?/h)',
          deviceId: '724b345d-8b5a-4196-9f5c-bf0bb2877b9a'
        },
        {
          deviceName: 'XS4气夹流量(m?/h)',
          deviceId: '10a2bfd2-0806-4f2e-a049-9f93e86f0154'
        },
        {
          deviceName: 'XS5气夹流量(m?/h)',
          deviceId: '187034af-0e7b-4e68-830d-04cd4ac79914'
        },
        {
          deviceName: 'XS6气夹流量(m?/h)',
          deviceId: '6a07ffd8-8234-4a8f-8561-8b653afdf78d'
        },
        {
          deviceName: 'XS7气夹流量(m?/h)',
          deviceId: '91e546b8-4231-4ee7-838f-5788ee3853b6'
        },
        {
          deviceName: 'SP10气夹压力(Pa)',
          deviceId: '26144e19-9dee-4fd5-bc7a-fc050df3e0ba'
        },
        {
          deviceName: 'SP1气夹压力(Pa)',
          deviceId: '42c18282-f054-4a06-bb38-41ae49a74c06'
        },
        {
          deviceName: 'SP2气夹压力(Pa)',
          deviceId: '84a0020d-1bf3-4197-9e9c-0fc199dd2b2c'
        },
        {
          deviceName: 'SP3气夹压力(Pa)',
          deviceId: '3f2065a4-9efc-4dd5-acea-c0a66501c3e9'
        },
        {
          deviceName: 'SP4气夹压力(Pa)',
          deviceId: 'a6259276-d98a-4872-8a11-6974f060bddf'
        },
        {
          deviceName: 'SP5气夹压力(Pa)',
          deviceId: 'eb3dc19b-68aa-4ecb-a1f2-359dee1075aa'
        },
        {
          deviceName: 'SP6气夹压力(Pa)',
          deviceId: '5b5fdc08-94c4-4fbb-a3ad-3d624fb01a8e'
        },
        {
          deviceName: 'SP7气夹压力(Pa)',
          deviceId: '926ec15a-310a-4b6f-a2fb-eceb2387a381'
        },
        {
          deviceName: 'SP8气夹压力(Pa)',
          deviceId: '0724d554-1469-4ba0-b33f-bbd7b75d46c9'
        },
        {
          deviceName: 'SP9气夹压力(Pa)',
          deviceId: '2e7f5e6e-baaa-4b37-8076-ac26c1deb570'
        },
        {
          deviceName: 'SS1气夹压力(Pa)',
          deviceId: '3dfaefca-7f5c-4621-8651-dc0620c03dfd'
        },
        {
          deviceName: 'SS2气夹压力(Pa)',
          deviceId: 'f1af9f00-6aaf-438c-946d-5d92531edf63'
        },
        {
          deviceName: 'SS3气夹压力(Pa)',
          deviceId: '411e0e34-794c-4b47-be07-2d208ab85426'
        },
        {
          deviceName: 'SS4气夹压力(Pa)',
          deviceId: 'f52927a4-c859-49a5-b572-909598a6553a'
        },
        {
          deviceName: 'SS5气夹压力(Pa)',
          deviceId: '79e86581-4ce4-4258-b556-7a9c8e184362'
        },
        {
          deviceName: 'SS6气夹压力(Pa)',
          deviceId: 'ae698974-7490-4743-b51d-9425d69fad7a'
        },
        {
          deviceName: 'SS7气夹压力(Pa)',
          deviceId: '0617448a-6f7f-4208-ad41-1fa5a73cbf7d'
        },
        {
          deviceName: 'XP10气夹压力(Pa)',
          deviceId: 'b6cfd0bd-38b8-423e-a571-4bfa17fd0b2a'
        },
        {
          deviceName: 'XP1气夹压力(Pa)',
          deviceId: '9fe0ad9b-f24d-4483-a887-4f914989a912'
        },
        {
          deviceName: 'XP2气夹压力(Pa)',
          deviceId: '58d4814f-f0bb-4ce3-b2ac-1842cd88aa15'
        },
        {
          deviceName: 'XP3气夹压力(Pa)',
          deviceId: 'cedde349-92c2-4328-815e-8b242d697e00'
        },
        {
          deviceName: 'XP4气夹压力(Pa)',
          deviceId: 'c5e46763-b55e-4745-8f34-41cbc9ebbd14'
        },
        {
          deviceName: 'XP5气夹压力(Pa)',
          deviceId: '47d82782-664f-45c8-9793-995e1636033a'
        },
        {
          deviceName: 'XP6气夹压力(Pa)',
          deviceId: '9ae3a5d5-3246-425d-9b91-b36309569103'
        },
        {
          deviceName: 'XP7气夹压力(Pa)',
          deviceId: '17cde557-82f5-4115-900f-652d49d20cf2'
        },
        {
          deviceName: 'XP8气夹压力(Pa)',
          deviceId: '091500ea-a5b1-4d9e-b1d4-9f5f847b5d22'
        },
        {
          deviceName: 'XP9气夹压力(Pa)',
          deviceId: '5813d054-c915-4b6b-9822-9cf0b6356998'
        },
        {
          deviceName: 'XS1气夹压力(Pa)',
          deviceId: '46205fb5-3a1d-41f4-a514-2d4457dce93f'
        },
        {
          deviceName: 'XS2气夹压力(Pa)',
          deviceId: '99c2ec37-519b-46a0-a150-bf0908842139'
        },
        {
          deviceName: 'XS3气夹压力(Pa)',
          deviceId: '44c47e63-ef2b-4626-9a9f-1c5984b9745e'
        },
        {
          deviceName: 'XS4气夹压力(Pa)',
          deviceId: '1be20527-90dd-4d5d-aa5c-aa894ecf7252'
        },
        {
          deviceName: 'XS5气夹压力(Pa)',
          deviceId: '7e582e68-b789-4730-b1e4-93c0b907ce78'
        },
        {
          deviceName: 'XS6气夹压力(Pa)',
          deviceId: '72872076-a0c2-413f-a915-1152ead1f5a7'
        },
        {
          deviceName: 'XS7气夹压力(Pa)',
          deviceId: '822951ab-7fcd-4a0b-bbce-136f8362ada7'
        }
      ]
    }
  },
  created() {
    this.getDevice()
    this.timeFunc = setInterval(() => {
      this.getDevice()
    }, this.REFRESH_SECOND)
  },
  destroyed() {
    clearInterval(this.timeFunc)
    this.timeFunc = null
  },
  methods: {
    refreshData() {
      this.loading = true
      this.getDevice()
      clearInterval(this.timeFunc)
      this.timeFunc = setInterval(() => {
        this.getDevice()
      }, this.REFRESH_SECOND)
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDevice() {
      this.$http
        .get(
          `/deviceData/Station?stationId=25a74940-1a2a-41a4-aca0-c1a09f57e928`
        )
        .then(res => {
          this.$store.commit('setLastRefreshTime')
          this.loading = false
          const __data = res.data
          this.topList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const { value, errorLevel } = this.findDeviceData(
                __data,
                item.deviceName
              )
              item.value = value
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
          this.bottomList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const { value, errorLevel } = this.findDeviceData(
                __data,
                item.deviceName
              )
              item.value = value
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
        })
    }
  }
}
</script>
<style scoped lang="scss">
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height:370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 60px;

      .legend {
        position: absolute;
        left: 25px;
        top: 25px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .supply:after {
          background: #3376c7;
        }

        .circle::after {
          background: #b33c86;
        }

        .exhaust:after {
          background: #c7798b;
        }

        .exhaust1:after {
          background: #f2bd42;
        }
      }

      .dir {
        position: absolute;
        top: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 100px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 100px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 290px;
        background: url("../../assets/image/nizhou/nizhou_line.png") no-repeat;
        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
          &-1 {
            top: 196px;
            left: 97px;
          }
          &-2 {
            top: 183px;
            left: 144px;
          }
          &-3 {
            top: 174px;
            left: 1016px;
          }
          &-4 {
            top: 194px;
            left: 1243px;
          }
        }
        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 70px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              &:first-child {
                font-size: 13px;
                white-space: nowrap;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 43%;
              top: 100%;
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.exhaust {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(253, 247, 250, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.circle {
            background: #b33c86;
            &:after,
            &:before {
              background: #b33c86;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #b33c86;
              }
            }
          }

          &.supply {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }

          &.exhaust1 {
            background: #f2bd42;

            &:after,
            &:before {
              background: #f2bd42;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #f2bd42;
              }
            }
          }
        }

        .ex1 {
          top: 192px;
          left: 128px;
          &::before {
            bottom: 48px;
            left: -36px;
            transform: rotate(74deg);
          }
          &::after {
            bottom: 81px;
            left: -24px;
          }
          .state-info {
            left: -100px;
            top: -66px;
          }
        }

        .ex2 {
          top: 178px;
          left: 184px;

          &::before {
            top: 64px;
            left: -62px;
            width: 105px;
            transform: rotate(-71deg);
          }

          &::after {
            top: 113px;
            left: -41px;
          }

          .state-info {
            right: 59px;
            top: 113px;
          }
        }

        .ex3 {
          top: 161px;
          left: 239px;

          &::before {
            top: -33px;
            left: -38px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 45px;
            top: -66px;
          }
        }

        .ex4 {
          top: 137px;
          left: 304px;

          &::before {
            bottom: -69px;
            width: 140px;
            left: -71px;
            transform: rotate(-82deg);
          }

          &::after {
            top: 153px;
            left: -25px;
          }

          .state-info {
            right: 42px;
            top: 154px;
          }
        }

        .ex5 {
          top: 116px;
          left: 355px;

          &::before {
            top: -34px;
            left: -33px;
            transform: rotate(79deg);
          }

          &::after {
            top: -68px;
            right: 21px;
          }

          .state-info {
            left: -97px;
            top: -66px;
          }
        }

        .ex6 {
          top: 115px;
          left: 391px;
          &::before {
            bottom: 48px;
            left: -20px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -98px;
            top: -66px;
          }
        }

        .ex7 {
          top: 139px;
          left: 454px;
          &::before {
            top: 82px;
            width: 140px;
            left: -75px;
            transform: rotate(-79deg);
          }

          &::after {
            top: 150px;
            right: 34px;
          }

          .state-info {
            right: 50px;
            top: 152px;
          }
        }

        .ex8 {
          top: 159px;
          left: 532px;

          &::before {
            left: -33px;
            top: -44px;
            width: 105px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -95px;
            left: 29px;
          }

          .state-info {
            left: 43px;
            top: -93px;
          }
        }

        .ex9 {
          top: 171px;
          left: 607px;
          &::before {
            top: 65px;
            right: -30px;
            width: 120px;
            transform: rotate(-66deg);
          }

          &::after {
            top: 119px;
            left: -53px;
          }

          .state-info {
            right: 70px;
            top: 120px;
          }
        }

        .ex10 {
          top: 178px;
          left: 709px;
          &::before {
            width: 60px;
            top: -23px;
            right: -22px;
            transform: rotate(90deg);
          }

          &::after {
            display: none;
          }

          .state-info {
            left: -29px;
            top: -96px;
          }
        }

        .ex11 {
          top: 171px;
          left: 811px;
          &::before {
            top: 63px;
            left: -33px;
            width: 120px;
            transform: rotate(69deg);
          }

          &::after {
            top: 118px;
            left: 48px;
          }

          .state-info {
            left: 64px;
            top: 120px;
          }
        }
        .ex12 {
          top: 159px;
          left: 886px;
          &::before {
            top: -44px;
            right: -37px;
            width: 105px;
            transform: rotate(79deg);
          }
          &::after {
            top: -95px;
            left: -24px;
          }
          .state-info {
            right: 41px;
            top: -93px;
          }
        }

        .ex13 {
          top: 139px;
          left: 948px;
          &::before {
            top: 81px;
            width: 145px;
            right: -76px;
            transform: rotate(79deg);
          }

          &::after {
            bottom: -137px;
            left: 34px;
          }

          .state-info {
            left: 51px;
            top: 152px;
          }
        }

        .ex14 {
          top: 115px;
          left: 1018px;
          &::before {
            bottom: 48px;
            right: -21px;
            transform: rotate(79deg);
          }

          &::after {
            bottom: 82px;
            left: -19px;
          }

          .state-info {
            left: -96px;
            top: -67px;
          }
        }

        .ex15 {
          top: 115px;
          left: 1047px;
          &::before {
            top: -34px;
            right: -33px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -19px;
          }

          .state-info {
            left: 37px;
            top: -66px;
          }
        }
        .ex16 {
          top: 150px;
          left: 1133px;
          &::before {
            bottom: -63px;
            right: -75px;
            width: 130px;
            transform: rotate(74deg);
          }
          &::after {
            bottom: -125px;
            right: -42px;
          }
          .state-info {
            left: 58px;
            top: 141px;
          }
        }
        .ex17 {
          top: 188px;
          left: 1223px;
          &::before {
            bottom: 61px;
            right: -56px;
            width: 100px;
            transform: rotate(-74deg);
          }
          &::after {
            bottom: 109px;
            right: -34px;
          }
          .state-info {
            right: -111px;
            top: -93px;
          }
        }
      }
    }
  }
}
</style>
